import { render, staticRenderFns } from "./Manutencao.vue?vue&type=template&id=d2a2e57c&scoped=true&"
import script from "./Manutencao.vue?vue&type=script&lang=js&"
export * from "./Manutencao.vue?vue&type=script&lang=js&"
import style0 from "./Manutencao.vue?vue&type=style&index=0&id=d2a2e57c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a2e57c",
  null
  
)

export default component.exports